import { gql } from '@apollo/client';
import { LocationHealthNoteFieldsFragment } from '../fragments/locationHealthNote';

export interface LocationHealthNote {
  id: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  createdBy: {
    id: string;
    fullName: string;
    username: string;
  };
}

export const LOCATION_HEALTH_NOTES = gql`
  query locationHealthNotes($locationHealthSummaryId: String!) {
    locationHealthNotes(locationHealthSummaryId: $locationHealthSummaryId) {
      ...LocationHealthNoteFields
    }
  }
  ${LocationHealthNoteFieldsFragment}
`;

export const CREATE_LOCATION_HEALTH_NOTE = gql`
  mutation createLocationHealthNote($data: CreateLocationHealthNoteInput!) {
    createLocationHealthNote(data: $data) {
      ...LocationHealthNoteFields
    }
  }
  ${LocationHealthNoteFieldsFragment}
`;

export const UPDATE_LOCATION_HEALTH_NOTE = gql`
  mutation updateLocationHealthNote($id: String!, $content: String!) {
    updateLocationHealthNote(id: $id, content: $content) {
      ...LocationHealthNoteFields
    }
  }
  ${LocationHealthNoteFieldsFragment}
`;

export const DELETE_LOCATION_HEALTH_NOTE = gql`
  mutation deleteLocationHealthNote($id: String!) {
    deleteLocationHealthNote(id: $id)
  }
`;
